import React from "react"
import _ from "lodash"
import "../../assets/css/pages/track_progress/progress-overview-row.css"
import { Link } from "react-router-dom"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faChevronRight,
  faLeaf,
  faUsers,
  faDna,
  faQuestion,
  faCloudSunRain,
  faPlus,
  faMinus,
  faHandPaper,
  faEgg,
  faGears,
  faVolcano,
  faChartSimple
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
library.add(
  faLeaf,
  faDna,
  faUsers,
  faQuestion,
  faCloudSunRain,
  faChevronRight,
  faPlus,
  faMinus,
  faHandPaper,
  faEgg,
  faGears,
  faVolcano,
  faChartSimple
)

class ProgressOverviewRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isExpanded: false }
  }

  //TODO: change the current icon mapping system, since some module titles cannot be used as property names (ex. Earth's systems)
  iconNameMapping = {
    Ecology: faLeaf,
    "Growth, Genetics & Natural Selection": faDna,
    "Cells to Organisms": faGears,
    "Weather and Climate": faCloudSunRain,
    General: faHandPaper,
    "6th Grade Math 2": faChartSimple,
    "Earth Systems": faVolcano
  }

  handleToggleExpansion = () => this.setState({ isExpanded: !this.state.isExpanded })

  getIconName = () => {
    return (
      this.iconNameMapping[
        this.props.title === `Earth’s Systems` ? "Earth Systems" : this.props.title
      ] || "question"
    )
  }

  getActionIcon = () => {
    if (this.props.subItems.length > 0) {
      return this.state.isExpanded ? "minus" : "plus"
    } else {
      return "chevron-right"
    }
  }

  handleActionClick = () => this.setState({ isExpanded: !this.state.isExpanded })

  getProgressStyle = percentage => ({ right: `${(1 - percentage) * 100}%` })

  getClassForProgressText = percentage => (percentage <= 0.1 ? "left-justified" : "right-justified")

  getItemSubtitle = (index, item) =>
    this.props.numberSubitems ? `${index + 1}. ${item.subtitle}` : item.subtitle

  hasQuestProgresses = questId => {
    const { quests } = this.props
    const selectedQuest = _.find(quests, q => q.id == questId)
    const workProductTypes = [
      "Categorization",
      "Argument Builder",
      "Research",
      "Flowchart",
      "Heredity Probability",
      "Frequency Chart"
    ]
    const progressTypes = _.flatMap(selectedQuest.work_product_progression, qp => qp.types)
    const filteredProgressTypes = _.filter(progressTypes, t => _.includes(workProductTypes, t))

    return !_.isEmpty(filteredProgressTypes)
  }

  render() {
    const { numberSubItems, title, subtitle, completionPercentage, subItems, quests } = this.props
    return (
      <div className='progress-overview-row'>
        <div className='primary-row'>
          <span className='module-icon'>
            <FontAwesomeIcon icon={this.getIconName()} />
          </span>
          <span className='module-name'>{title}</span>
          <span className='content-name'>{subtitle}</span>
          <span className='progress-bar'>
            <span style={this.getProgressStyle(completionPercentage)} className='progress-fill'>
              <p className={this.getClassForProgressText(completionPercentage)}>
                {Math.round(completionPercentage * 100)}%
              </p>
            </span>
          </span>
          <span onClick={this.handleActionClick} className='expansion-toggle'>
            <FontAwesomeIcon icon={this.getActionIcon()} />
          </span>
        </div>
        <div className='secondary-rows'>
          {this.state.isExpanded &&
            _.map(subItems, (item, index) => (
              <div key={this.getItemSubtitle(index, item)} className='secondary-row'>
                <span className='content-name'>
                  {numberSubItems ? index + 1 : ""} {this.getItemSubtitle(index, item)}
                </span>
                <span className='progress-bar'>
                  <span
                    style={this.getProgressStyle(item.completionPercentage)}
                    className='progress-fill'
                  >
                    <p className={this.getClassForProgressText(item.completionPercentage)}>
                      {Math.round(item.completionPercentage * 100)}%
                    </p>
                  </span>
                </span>
                {this.hasQuestProgresses(item.id) && (
                  <span className='expansion-toggle'>
                    <Link to={`/track_progress/${item.id}`}>
                      <FontAwesomeIcon icon='chevron-right' />
                    </Link>
                  </span>
                )}
                {!this.hasQuestProgresses(item.id) && (
                  <span className='expansion-toggle disabled'>
                    <FontAwesomeIcon icon='chevron-right' color='#D9DCE0' />
                    <div className='hint-container'>
                      <div className='hint-box'>
                        <div className='arrow'></div>
                        <span className='hint'>
                          <b>Non-gradable Content</b>: This quest built knowledge for your students,
                          but did not ask them to do any work product tasks that could generate
                          valid assessment data. If it is part of a storyline, another quest will
                          require them to produce work product data for assessment.
                        </span>
                      </div>
                    </div>
                  </span>
                )}
              </div>
            ))}
        </div>
      </div>
    )
  }
}

ProgressOverviewRow.defaultProps = {
  subItems: []
}

export default ProgressOverviewRow
